import { render } from "./contributionItemModal.vue?vue&type=template&id=924b071c&scoped=true"
import script from "./contributionItemModal.vue?vue&type=script&lang=js"
export * from "./contributionItemModal.vue?vue&type=script&lang=js"

import "./contributionItemModal.vue?vue&type=style&index=0&id=924b071c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-924b071c"]])

export default __exports__